import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Institution, IUsers, UserRights, IClose } from '../../shared/model/institution';
import { InstitutionsService } from '../../shared/services/institutions.service';
import { SaveService } from '../../shared/services/save.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { UserService } from '../../shared/services/user.service';
import { IFavorite } from '../../shared/model/user';
import { ConfigService } from '../../shared/services/config.service';
import { Config } from '../../shared/model/config';

@Component({
  selector: 'institution-create',
  templateUrl: './institution-create.component.html',
  styleUrls: ['./institution-create.component.css']
})
export class InstitutionCreateComponent implements OnInit {

  permissionDenied: boolean;

  constructor(private institutionsService: InstitutionsService,
    private saveService: SaveService, private router: Router,
    public userService: UserService,
    public configService: ConfigService,
    public dialog: MatDialog) { }

  form: FormGroup;

  ngOnInit() {
    this.saveService.setTitle("Ajouter une institution");
  }

  onOutForm(form: FormGroup) {
    this.form = form;
  }

  onSubmit = (form) => {
    console.log("onSubmit form = ", form)
    if (form.valid) {
      this.save(form);
    }
  }

  onCancel = () => {
    this.router.navigate(['institution-list']);
  }

  formatInstitution(value): Institution {
    console.log("formatInstitution value = ", value)
    const currentUser = this.saveService.getUser();
    const institutionId = this.saveService.getNextConfigInstitutionID();
    const users: IUsers[] = [{ 
      user: currentUser.email, 
      rights: UserRights[UserRights.ADMIN],
      userId: currentUser.$key 
    }];
    const close: IClose[] = [{
      type: 'student',
      ind: true
    }]
    const student = (value.student ? true : false)
    const guardDuty = (value.guardDuty ? true : false)
    const buses = (value.buses ? true : false)
    const teacher = (value.teacher ? true : false)
    const smsNotification = (value.smsNotification ? true : false)
    const emailNotification = (value.emailNotification ? true : false)
    const phoneNotification = (value.phoneNotification ? true : false)
    const powerUserTransfert = (value.powerUserTransfert ? true : false)
    const preSchool = (value.preSchool ? true : false)
    const primarySchool = (value.primarySchool ? true : false)
    const secondarySchool = (value.secondarySchool ? true : false)
    const adultSchool = (value.adultSchool ? true : false)
    const professionnelSchool = (value.professionnelSchool ? true : false)
    const collegeSchool = (value.collegeSchool ? true : false)
    const universitySchool = (value.universitySchool ? true : false)
    const languageFrench = (value.languageFrench ? true : false)
    const languageEnglish = (value.languageEnglish ? true : false)
    return new Institution(
      "",
      institutionId,
      value.institutionName,
      value.institutionAddress,
      value.institutionCity,
      value.institutionProv,
      value.institutionPostalCode,
      value.institutionCountry,
      value.institutionPhone,
      value.institutionPhoneExt,
      value.institutionEmail,
      value.institutionRespOrgId,   /*****TO BE DETERMINER ID******** */
      value.institutionRespOrgName,
      value.institutionAdmRegion,
      value.institutionType,
      value.contactLastName,
      value.contactFirstName,
      value.contactTitle,
      value.contactPhone,
      value.contactPhoneExt,
      currentUser.email,
      student,
      guardDuty,
      buses,
      teacher,
      smsNotification,
      emailNotification,
      phoneNotification,
      powerUserTransfert,
      preSchool,
      primarySchool,
      secondarySchool,
      adultSchool,
      professionnelSchool,
      collegeSchool,
      universitySchool,
      languageFrench,
      languageEnglish,
      users,
      close)
  }

  save(form) {

    var institutionKey = this.institutionsService.getNewInstitutionKey();
    this.institutionsService.saveInstitution(institutionKey, this.formatInstitution(form.value))
      .subscribe(
      () => {
        // RENDU ICI ICI ICI ICI
        // Récupéré l'id de l'institution créé param res.quelque chose BUG DATA TO SAVE institution-service
        console.info(`institution saved ${institutionKey}`);
        let user = this.saveService.getUser();
        let favoriteUser: IFavorite = { "institution": institutionKey, type: "ADMIN" };
        user.favoriteInstitution.push(favoriteUser);
        this.userService.saveUser(user.$key, user).subscribe(
          () => {
            console.info(`User saved ${user.$key}`);
            this.saveService.setUser(user);
            this.router.navigate(['responsible-dashboard']);
          },
          err => console.error(`Error saving user ${user.$key} Error = ${err}`)
        );
      },
      err => {
        console.error(`error creating institution ${institutionKey} - Error = ${err}`);
        if (err.toString().indexOf("PERMISSION_DENIED") !== -1) {
          this.openDialog()
        }
      });

  }

  openDialog(): void {
    let dialogRef = this.dialog.open(ConfirmDialogComponent, {
      height: '250px',
      width: '300px',
      position: { 'top': '150px' },
      data: {
        content: "Désolé vous devez vous connecter avec un compte de responsable d'institution pour être en mesure de créer une nouvelle institution",
        title: "Création interdite",
        twoButton: false
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.router.navigate(['login']);
    });
  }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/institutions/institution-create/institution-create.component.ts